/* WidthPro — editorial motion: sticky timeline, testimonial rotator,
   pill-nav hide/show, hero parallax. Respects reduced-motion. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Sticky scroll timeline ---- */
  document.querySelectorAll('[data-timeline]').forEach(function (tl) {
    var slides = Array.prototype.slice.call(tl.querySelectorAll('.timeline__slide'));
    var dots = Array.prototype.slice.call(tl.querySelectorAll('.timeline__dot'));
    if (!slides.length) return;
    var current = -1;
    function setActive(i) {
      if (i === current) return;
      current = i;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }
    setActive(0);
    function onScroll() {
      var rect = tl.getBoundingClientRect();
      var stage = tl.querySelector('.timeline__stage');
      var stageH = stage ? stage.offsetHeight : window.innerHeight;
      var scrollable = tl.offsetHeight - stageH;
      if (scrollable <= 0) return;
      var progress = Math.min(1, Math.max(0, -rect.top / scrollable));
      var idx = Math.min(slides.length - 1, Math.floor(progress * slides.length));
      setActive(idx);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  });

  /* ---- Testimonial / quote rotator ---- */
  document.querySelectorAll('[data-rotator]').forEach(function (rot) {
    var items = Array.prototype.slice.call(rot.querySelectorAll('.rotator__item'));
    var dots = Array.prototype.slice.call(rot.querySelectorAll('.rotator__dot'));
    if (items.length < 2) { if (items[0]) items[0].classList.add('is-active'); return; }
    var i = 0, timer;
    function show(n) {
      i = (n + items.length) % items.length;
      items.forEach(function (it, k) { it.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function start() { if (!reduce) timer = setInterval(function () { show(i + 1); }, 5000); }
    function reset() { clearInterval(timer); start(); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); reset(); }); });
    show(0); start();
  });

  /* ---- Pill nav: hide on scroll down, show on scroll up ---- */
  var nav = document.querySelector('[data-pillnav]');
  if (nav) {
    var lastY = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > lastY && y > 260) nav.classList.add('is-hidden');
      else nav.classList.remove('is-hidden');
      lastY = y;
    }, { passive: true });
  }

  /* ---- Social reels lightbox ---- */
  var reelModal = document.querySelector('[data-reel-modal]');
  if (reelModal) {
    var reelBody = reelModal.querySelector('[data-reel-modal-body]');
    function closeReel() { reelModal.classList.remove('is-open'); reelBody.innerHTML = ''; document.body.classList.remove('cart-open'); }
    document.querySelectorAll('[data-reel-youtube]').forEach(function (card) {
      card.addEventListener('click', function () {
        var id = card.getAttribute('data-reel-youtube');
        reelBody.innerHTML = '<iframe src="https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0" title="Video" allow="autoplay; encrypted-media; fullscreen" allowfullscreen></iframe>';
        reelModal.classList.add('is-open');
        document.body.classList.add('cart-open');
      });
    });
    document.querySelectorAll('[data-reel-link]').forEach(function (card) {
      card.addEventListener('click', function () {
        var url = card.getAttribute('data-reel-link');
        if (url) window.open(url, '_blank', 'noopener');
      });
    });
    reelModal.addEventListener('click', function (e) { if (e.target === reelModal) closeReel(); });
    var rc = reelModal.querySelector('[data-reel-modal-close]');
    if (rc) rc.addEventListener('click', closeReel);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeReel(); });
  }

  /* ---- Hero parallax ---- */
  if (!reduce) {
    var heroImg = document.querySelector('.hero-bleed__img img');
    if (heroImg) {
      window.addEventListener('scroll', function () {
        var y = window.scrollY;
        if (y < window.innerHeight * 1.2) heroImg.style.transform = 'translateY(' + (y * 0.18) + 'px) scale(1.06)';
      }, { passive: true });
      heroImg.style.willChange = 'transform';
      heroImg.style.transform = 'scale(1.06)';
    }
  }
})();
